import script from "./PostEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./PostEdit.vue?vue&type=script&setup=true&lang=js"

import "./PostEdit.vue?vue&type=style&index=0&id=6e02dd89&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e02dd89"]])

export default __exports__